import { IYantraCard } from "../../entities/yantras/yantraCards";
import { Box, CardMedia, Typography, keyframes } from "@mui/material";
import { useCardstore } from "../../stores/cardsStore/useCardsStore";
import { useTranslate } from "../../hooks/useTranslate";
import { useMemo } from "react";
import CountUp from "react-countup";

type Props = {
  card: IYantraCard;
  payment: number;
};

const winBetCashPlus = keyframes`
    from { 
        color: #eeee2c;
    }
    to { 
        color: rgba(255, 255, 255, 1);
    }
`;

export default function WinnerNotification({ card, payment }: Props) {
  const { yantrasColumns } = useCardstore();
  const { t } = useTranslate();
  const winningColumn = useMemo(
    () =>
      yantrasColumns.find((column) =>
        column.cards.find((c) => c.id === card.id)
      ),
    [yantrasColumns]
  );
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        zIndex: 11,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      {payment > 0 && (
        <CountUp
          start={0}
          end={payment}
          duration={3}
          separator=","
          decimals={2}
          decimal="."
          delay={0}
          //   prefix="$"
        >
          {({ countUpRef }) => (
            <Box
              sx={{
                zIndex: 12,
                animationDuration: "3.5s",
                animationIterationCount: 1,
                animationDirection: "normal",
                animationTimingFunction: "cubic-bezier(0.7, 0, 0.84, 0)",
                animationFillMode: "forwards",
                animationDelay: "0s",
                animationName: `${winBetCashPlus}`,
              }}
            >
              <Typography
                ref={countUpRef}
                sx={{
                  fontSize: (theme) => theme.typography.pxToRem(45),
                  fontFamily: "sans-serif",
                  fontWeight: "bold",
                  textShadow: "3px 3px 2px #000000",
                  textAlign: "center",
                }}
              />
            </Box>
          )}
        </CountUp>
      )}
      <Typography
        sx={{
          fontFamily: "sans-serif",
          fontSize: (theme) => theme.typography.pxToRem(22),
          color: "#FFFFFF",
        }}
      >
        {t("notifications.winner")}
      </Typography>
      <Box
        sx={{
          bgcolor: winningColumn?.borderColor || "transparent",
          p: 2,
          borderRadius: 1.5,
          boxShadow: "0px 0px 10px 3px #d3b978",
        }}
      >
        <CardMedia
          sx={{
            aspectRatio: "1",
            objectFit: "cover",
            width: (theme) => ({
              xs: "30vw",
              sm: theme.spacing(10),
              md: theme.spacing(20),
            }),
          }}
          image={card.image}
          title={card.name}
        />
      </Box>
      <Typography
        sx={{
          fontFamily: "sans-serif",
          fontSize: (theme) => theme.typography.pxToRem(14),
          color: "#FFFFFF",
        }}
      >
        {card.name}
      </Typography>
    </Box>
  );
}
